module.exports = __webpack_public_path__ + "img/idcode1.c0f460e8.png";